import { useMemo } from 'react';


export const useIsExternalLink = (url: string): boolean =>  useMemo( () => (/https?/u).test(url) ,[url] );
